export const STORAGE_ENV_KEY = 'STORAGE_ENV';
export const PREVIOUS_ENV_KEY = 'PREVIOUS_ENV';

// All env vars must be added here as NextJS swaps out the keys for the values at build time,
// so we can't access them dynamically (e.g. process.env[key]).
// We could Create a script to automatically create this at compile time, but not all of these
// exist in the .env files (e.g. NEXT_PUBLIC_DATA_DOG_APPLICATION_ID which comes from the CI secrets)
export const originalEnvironmentVariables = {
  SKIP_PREFLIGHT_CHECK: process.env.SKIP_PREFLIGHT_CHECK,
  NEXT_PUBLIC_STAGE: process.env.NEXT_PUBLIC_STAGE,
  NEXT_PUBLIC_REGION: process.env.NEXT_PUBLIC_REGION,
  NEXT_PUBLIC_USER_POOL_ID: process.env.NEXT_PUBLIC_USER_POOL_ID,
  NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID: process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID,
  NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
  NEXT_PUBLIC_REDIRECT_SIGN_IN: process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN,
  NEXT_PUBLIC_REDIRECT_SIGN_OUT: process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT,
  NEXT_PUBLIC_S3_BUCKET: process.env.NEXT_PUBLIC_S3_BUCKET,
  NEXT_PUBLIC_FORGEROCK_LOGOUT: process.env.NEXT_PUBLIC_FORGEROCK_LOGOUT,
  NEXT_PUBLIC_FORGEROCK_API_KEY: process.env.NEXT_PUBLIC_FORGEROCK_API_KEY,
  NEXT_PUBLIC_FORGEROCK_REDIRECT_URI: process.env.NEXT_PUBLIC_FORGEROCK_REDIRECT_URI,
  NEXT_PUBLIC_BRANCH_HUB_PROFILE: process.env.NEXT_PUBLIC_BRANCH_HUB_PROFILE,
  NEXT_PUBLIC_BRANCH_HUB_PROFILE_V2: process.env.NEXT_PUBLIC_BRANCH_HUB_PROFILE_V2,
  NEXT_PUBLIC_RELEASE_2_POINT_1: process.env.NEXT_PUBLIC_RELEASE_2_POINT_1,
  NEXT_PUBLIC_BRANCH_HUB_CT: process.env.NEXT_PUBLIC_BRANCH_HUB_CT,
  NEXT_PUBLIC_BRANCH_HUB_BO: process.env.NEXT_PUBLIC_BRANCH_HUB_BO,
  NEXT_PUBLIC_DISABLE_AUTO_LOGOUT: process.env.NEXT_PUBLIC_DISABLE_AUTO_LOGOUT,
  NEXT_PUBLIC_DATA_DOG_SITE: process.env.NEXT_PUBLIC_DATA_DOG_SITE,
  NEXT_PUBLIC_POL_DEVICE_SERVER_SIMULATED: process.env.NEXT_PUBLIC_POL_DEVICE_SERVER_SIMULATED,
  NEXT_PUBLIC_DATA_DOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID,
  NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN,
  NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_KEY: process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_KEY,
};

export const visibleEnvironmentVariables = (() => {
  // Warning: variables added here will be available for editing
  const visibleEnvVarKeys: (keyof typeof originalEnvironmentVariables)[] = [
    'NEXT_PUBLIC_STAGE',
    'NEXT_PUBLIC_REDIRECT_SIGN_OUT',
    'NEXT_PUBLIC_FORGEROCK_LOGOUT',
    'NEXT_PUBLIC_BRANCH_HUB_PROFILE',
    'NEXT_PUBLIC_RELEASE_2_POINT_1',
    'NEXT_PUBLIC_BRANCH_HUB_CT',
    'NEXT_PUBLIC_BRANCH_HUB_BO',
    'NEXT_PUBLIC_POL_DEVICE_SERVER_SIMULATED',
    'NEXT_PUBLIC_S3_BUCKET',
  ];

  const definedEnvVars: Record<string, string> = {};
  visibleEnvVarKeys.forEach((key) => {
    const value = originalEnvironmentVariables[key];
    if (!value) return;
    definedEnvVars[key] = value;
  });

  return definedEnvVars;
})();

//Checks if this variable has been configured by the Environment Variable Config screen, if not returns the value from process.env
export const getEnvVar = (
  envVarKey: keyof typeof originalEnvironmentVariables,
): string | undefined => {
  const originalEnvVar = originalEnvironmentVariables[envVarKey];

  if (typeof localStorage === 'undefined') return originalEnvVar;

  const storageEnvJson = localStorage.getItem(STORAGE_ENV_KEY);
  if (!storageEnvJson) return originalEnvVar;

  const storageEnv = JSON.parse(storageEnvJson);
  const value = storageEnv[envVarKey];

  if (!value) return originalEnvVar;

  return value as string;
};
